import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import Typography from '@mui/material/Typography';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import TaskGroupDialog from '../CreateDialogue/TaskGroupDialog';
import EditTaskGroupDialog from '../EditDialogue/EditTaskGroupDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,permissions,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');

export default function TaskGoupsTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [TaskGroups, setTaskGroup] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const timerRef = React.useRef(null);

	async function  timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
	};
    
    React.useEffect(() => {
	checkAuthentication();
        if (refresh) {
			const taskGP = async()=>{
			try{
			await timeout(1000); //for 1 sec delay
			fetch('api/task_group', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
                    setTaskGroup(json)
                    setIsLoading(false);
                        logger('inuseEffect')
                })
                 } catch (error) {
                    console.error('Error loading data:', error);
                	}
                } 
            taskGP();
            setRefresh(false);
       	 }
    })

    const handleDialogCallback = (childData) => {
        fetch("api/task_group", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "task_group": {
                    "Name": childData.Name,
                    "IsActive": childData.IsActive
                },
                "PropList": childData.PropList
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("api/task_group", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "task_group": {
                    "GroupID": childData.GroupID,
                    "Name": childData.Name,
                    "IsActive": childData.IsActive
                },
                "group_prop": childData.PropList
            })
        })
        logger('editcallback',childData);
        setRefresh(true);
    };

    const columns = [];
    if (permissions.CreateTaskGroup == 1) {
       	const adminActions =  {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    logger('TaskGroupIndex', dataIndex)
                    return (
                        <div>
                            <EditTaskGroupDialog handleEditCallback={handleEditCallback} data={TaskGroups[dataIndex]} />
                        </div>
                    );
                }

            }
        };
        columns.push(adminActions);
    }
     const columns1 = [
        {
            name: "Name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                filterList: [1],
                customFilterListOptions:
                {
                    render: v => {
                        if (v === 0) {
                            return "Show InActive";
                        }
                        if (v === 1) {
                            return "Show Active";
                        }
                        return val;
                    },
                },
                filterOptions: {
                    renderValue: val => {
                        if (val === 0) {
                            return "InActive";
                        }
                        if (val === 1) {
                            return "Active";
                        }
                        return val;
                    }
                }, 
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            {(TaskGroups[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
        }
    ];
    
    columns.push(...columns1);

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('TaskGrprowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('TaskGrprowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'TaskGroup.xlsx', columnIndexToRemove:0})
			return false;
		},
        customToolbar: () => permissions.CreateTaskGroup===1 && !isLoading ? (
            <TaskGroupDialog handleDialogCallback={handleDialogCallback} />
        ):(<></>)
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="TaskGroupsTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Task Types
                        </Typography>
                    }
                    data={isLoading ? [] :TaskGroups}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}

                />
                </Box>
            </MuiThemeProvider>
        </Box>
    );
}